export default class LoginSelectors {
    static getIsLoggedIn = (state) => state.login.isLoggedIn;
    static getWantLogin = (state) => state.login.wantLogin;
}



// WEBPACK FOOTER //
// ./app/selectors/login.js